<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row no-gutters>
                <v-col cols="auto" class="pa-6 pb-0 pt-1 pr-2 header" >
                  Current Customer
                </v-col>
                <v-col cols="full">
                  <v-text-field 
                    dense 
                    outlined 
                    hide-details="auto"
                    clearable
                    readonly
                    v-model="currentCustomer"
                  />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                    ]"
                    @btnRetrieve="btnRetrieve()"
                  >
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-1 subTitle">Customer Code: </span>
                          <v-col cols="2">
                            <v-text-field 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable
                              v-model="customerCode"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Customer Name: </span>
                          <v-col cols="2">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              v-model="customerName"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Use Div: </span>
                          <v-col cols="2">
                            <v-select
                              v-model="useDiv"
                              :items="useDivList"
                              return-object
                              single-line
                              clearable
                              outlined
                              dense
                              label="Select"
                              @change="changeUseDiv()"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="12" align="right" class="pr-2 customer">* Click customer code.</v-col>
                  </v-row>
                  <DxDataGrid id="admZ010" 
                    class="hipGridHeight2" 
                    :ref="admZ010Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxColumn data-field="rnum" caption="NO" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="custCd" caption="Code" width="7%" data-type="string" alignment="center" cell-template="custCdTemplate" :allow-editing="false" />
                      <template #custCdTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 custCdBtn" @click="custCdBtn(data)">
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxColumn data-field="custNm" caption="Customer Name" width="27%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="custNo" caption="Ref. No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="represent" caption="Represent" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="tel" caption="Tel" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="fax" caption="Fax" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="addr" caption="Address" width="20%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="useDiv" caption="Use" width="3%" data-type="string" alignment="center" :allow-editing="false" />

                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <DxPopup :visible.sync="cellVisible" :show-close-button="true" :show-title="true" :title="$t('Change Customer')" height="210px" width="300px">
      <v-row no-gutters>
        <v-col cols="12" align="center" style="fontSize: 14pt; fontWeight: bold;">Customer changed.</v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" >Code : {{changeCode}}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" >Name : {{changeName}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center">
          <v-btn tile outlined width="60px" height="30" class="releaseBtn" ref="cancelBtn"
            @click="close()">
            {{$t('OK')}}
          </v-btn>
        </v-col>
      </v-row>
    </DxPopup>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton } from 'devextreme-vue/data-grid'
import { DxPopup } from 'devextreme-vue/popup';
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getCustomerList } from '@/api/view/hycot/Z/admZ010.js'

export default {
  name: 'admZ010',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxButton,
    DxPopup
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useDivList: ['All' ,'Use Only', 'Not Use Only'],

      admZ010Ref: 'admZ010Ref',
      gridMainList: [],

      currentCustomer: '',

      //Retrieve text input
      customerCode: '',
      customerName: '',
      useDiv: 'All',
      useDivGbn: '',

      makerCd: '',
      makerNm: '',

      //popup
      cellVisible: false,
      changeCode: '',
      changeName: '',

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.admZ010Ref)
    },
  },
  mounted(){
    this.doSearchMain()
  },
  methods: {
    btnRetrieve(){
      if(this.customerCode === null){
        this.customerCode = ''
      } else if(this.customerName === null){
        this.customerName = ''
      } else if(this.useDiv === null){
        this.useDiv = ''
      }
      this.customerName = this.customerName.toUpperCase()
      this.doSearchMain()
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        custCd: this.customerCode,
        custNm: this.customerName,
        useDiv: this.useDivGbn
      }
      await getCustomerList(params).then(res => {
        // console.log(" RES : " , res)
        this.gridMainList = res.list
        res.list.forEach(e => {
          e.id = e.rnum
          if(e.custCd == this.$store.state.user.makerCd){
            this.custNm = e.custNm
          }
        });
        this.currentCustomer = this.$store.state.user.makerCd + ' - ' + this.custNm

      }).finally(() => {
        this.endLoading()
      })

    },
    changeUseDiv(){
      if(this.useDiv === 'Use Only'){
        this.useDivGbn = 'Y'
      } else if(this.useDiv === 'Not Use Only'){
        this.useDivGbn = 'N'
      } else {
        this.useDivGbn = ''
      }
      this.doSearchMain()
    },
    custCdBtn(e){
      this.vToastifyPrompt(
        this.$t('Do you want to change customer?'),
        'info',
          current => {
            this.$store.commit('user/SET_MAKER_CD', e.value)
            this.$store.commit('user/SET_MAKER_NM', e.values[2])
            this.changeCode = e.value,
            this.changeName = e.values[2],
            this.currentCustomer = e.value + ' - ' + e.values[2]
            this.cellVisible = true
          },
          null,
          true
        )
    },
    close(){
      this.cellVisible = false
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px'
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .customer {
    color: red;
    font-weight: bold;
  }
  .header {
    border: 1px solid gray;
    background-color: rgb(223,227,213);
    color: black;
  }
  .custCdBtn {
    font-weight: bold;
  }
  .custCdBtn:hover {
    color: #4980BC;
  }
  .releaseBtn {
  background-color: rgb(135,155,119);
  margin-right: 6px;
  font-size: 12pt;
  color: white;
}
</style>